import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToRestriction = {
  [titleId: string]: WpsTypes.atv.wps.RestrictionFragmentModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.restriction,
  {} as TitleIdToRestriction
)
